import { memo } from 'react';
import { formatCurrency } from '@alamo/utils';

import { cn } from '../../../lib/cn';

interface CurrencyCellProps {
  value: number | null | undefined;
  className?: string;
}

export const CurrencyCell = memo(function CurrencyCell({
  value,
  className,
}: CurrencyCellProps) {
  if (value === null || value === undefined) {
    return <span className="text-slate-400">-</span>;
  }

  return (
    <span className={cn('tabular-nums', className)}>
      {formatCurrency(value)}
    </span>
  );
});
